module.exports = __webpack_public_path__ + "img/villager-min.bff49c22.png";